<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <TableLoading v-if="institution.publicId === '0'"/>
    <div v-else>
      <div class="row">
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="text-muted">
                        <h4 class="mb-3">{{institution.name}}</h4>
                        <p class="mb-3"><b>Phone:</b> {{institution.phoneNumber}}</p>
                        <p class="mb-2"><b>Email:</b> {{institution.email}}</p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-5">
                      <div>
                        <p class="text-muted text-truncate mb-2">Category</p>
                        <h5 class="mb-0">{{institution.typeId.name}}</h5>
                      </div>
                    </div>
                    <div class="col-3">
                      <div>
                        <p class="text-muted text-truncate mb-2">Status</p>
                        <h5 v-if="institution.activeState === true" class="mb-0"><span class="badge rounded-pill font-size-11 badge-soft-primary">Active</span></h5>
                        <h5 v-else class="mb-0"><span class="badge rounded-pill font-size-11 badge-soft-dark">Inactive/Closed</span></h5>
                      </div>
                    </div>
                  </div>
                  <hr v-if="checkForPermission(change_branch_status_permission)"/>
                  <div v-if="checkForPermission(change_branch_status_permission)" class="row">
                    <div class="col-5">
                      <div v-if="institution.activeState === true">
                        <b-button v-if="statusLoading" variant="dark" size="sm" class="px-5 py-2 text-white" disabled>
                          <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                          Loading
                        </b-button>
                        <b-button v-else variant="danger" size="sm" class="px-5 py-2 text-white" @click="toggleCustomerStatus">
                          Deactivate
                        </b-button>
                      </div>
                      <div v-else>
                        <b-button v-if="statusLoading" variant="dark" size="sm" class="px-5 py-2 text-white" disabled>
                          <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                          Loading
                        </b-button>
                        <b-button v-else variant="success" size="sm" class="px-5 py-2 text-white" @click="toggleCustomerStatus">
                          Activate
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="text-muted">
                        <p class="mb-3"><b>KRA PIN:</b> {{institution.pin}}</p>
                        <p class="mb-3"><b>Postal Code:</b> {{institution.postalCode}}</p>
                        <p class="mb-3"><b>Description:</b> {{institution.description}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="text-muted">
                        <p class="mb-3"><b>Bank Name:</b> {{institution.bankName}}</p>
                        <p class="mb-3"><b>Branch:</b> {{institution.branch}}</p>
                        <p class="mb-3"><b>Account Name:</b> {{institution.accountName}}</p>
                        <p class="mb-3"><b>Account number:</b> {{institution.accountNumber}}</p>
                        <p class="mb-3"><b>Invoicing Period:</b> {{institution.invoicingPeriod}}</p>
                        <p class="mb-3"><b>Expected Payment Period:</b> {{institution.expectedPaymentPeriod}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6" v-if="checkForPermission(add_branch_permission)">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Add Branch</h4>
              <branch-form button_text="Add Branch" @branchAction="addBranch" :loading="branchLoading"/>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">All Branches</h4>
              <all-branches :rows="institution.branchesPaginated" :current-page="branchCurrentPage" @updateBranch="updateSingleCustomer" @onSearch="searchFn"/>
              <b-pagination
                  v-model="branchCurrentPage"
                  :total-rows="institution.branchesPaginated.total"
                  :per-page="perPage"
                  size="lg"
                  align="center"
                  class="mt-3"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import AllBranches from "@/components/customers/all-branches";
import BranchForm from "@/components/customers/branch-form";
import {SINGLE_CUSTOMER} from "@/gql/customers";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";

export default {
  page: {
    title: "Single Customer",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, BranchForm, AllBranches, PageHeader, Layout},
name: "single-customer",
  data() {
    return {
      title: "Single Customer",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Single Customer",
          active: true
        }
      ],
      add_branch_permission: permissions.add_branch_permission,
      change_branch_status_permission: permissions.edit_customer_profile,
      branchCurrentPage: 1,
      perPage: 30,
      branchSearchKeyword: '',
      institution: {
        publicId: '0',
        typeId: {
          publicId: "",
          name: "",
        },
        name: "",
        pin: "",
        description: "",
        phoneNumber: "",
        email: "",
        postalCode: "",
        bankName: "",
        branch: "",
        accountName: "",
        accountNumber: "",
        invoicingPeriod: "",
        expectedPaymentPeriod: "",
        activeState: false,
        branchesPaginated: {
          total: "",
          objects: []
        }
      },
      branchLoading: false,
      statusLoading: false,
    }
  },
  apollo: {
    institution: {
      query: SINGLE_CUSTOMER,
      variables() {
        return {
          id: this.$route.params.id,
          branchCurrentPage: this.branchCurrentPage,
          branchSearchKeyword: this.branchSearchKeyword
        }
      }
    }
  },
  watch: {
    branchCurrentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  mounted() {
    this.branchCurrentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    ... mapActions({
      addBranchFn: 'customers/addNewCustomerBranch',
      updateCustomerStatus: 'customers/updateCustomerStatus',
    }),
    async addBranch(data){
      this.branchLoading = true
      await this.addBranchFn(data).then(resp => {
        this.updateSingleCustomer()
        if(resp.publicId){
          successToast('New Branch added successfully')
          this.$forceUpdate()
        }
      }).finally(()=> {
        this.branchLoading = false
      })
    },
    async toggleCustomerStatus() {
      this.statusLoading = true
      await this.updateCustomerStatus({id: this.$route.params.id}).then(resp => {
        if (resp.publicId) {
          successToast('Updated customer status')
        }
      }).finally(() => {
        this.statusLoading = false
        this.updateSingleCustomer()
      })
    },
    updateSingleCustomer(){
      this.$apollo.queries.institution.refetch()
    },
    searchFn(data){
      this.branchSearchKeyword = data
    }
  }
}
</script>

<style scoped>

</style>
